import { Box, Fade } from '@chakra-ui/react';
import React from 'react';
import { RemoveScroll } from 'react-remove-scroll';

import { NavData } from '../types';
import MainNavigation from './MainNavigation';
import CloseButton from './MainNavigation/Menu/Button/CloseButton';
import { useNavigation } from './Navigation.context';

interface NavigationProps {
  data: NavData;
  children?: React.ReactNode;
}

const CloseButtonContainer: React.FC = () => {
  const { main } = useNavigation();
  if (!main.active) {
    return null;
  }
  return (
    <Box
      display={{ base: 'block', laptop: 'none' }}
      position="fixed"
      top={1}
      right={1}
      zIndex={1}
    >
      <Fade in>
        <CloseButton onClick={main.close} />
      </Fade>
    </Box>
  );
};

const ContextualNavigation: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  const { main } = useNavigation();

  return (
    <Box
      as="nav"
      className="WLHeader-PrimaryNavBar"
      position="relative"
      zIndex={{ base: 0, laptop: 12 }}
      width="100%"
      height={{ base: '113px', laptop: '81px' }}
      backgroundColor="white"
    >
      <RemoveScroll removeScrollBar allowPinchZoom enabled={main.active}>
        <CloseButtonContainer />
        <MainNavigation />
      </RemoveScroll>
    </Box>
  );
};

const Navigation: React.FC<NavigationProps> = ({
  children,
  data,
  ...props
}) => <ContextualNavigation {...props}>{children}</ContextualNavigation>;

export default Navigation;
